const GET_ADDRESSES = 'GET_ADDRESSES';
export { GET_ADDRESSES }